"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const gsap_1 = require("gsap");
const THREE = __importStar(require("three"));
const Chapter_1 = __importDefault(require("./Chapter"));
const SplashCircle_1 = __importDefault(require("../three/element/SplashCircle"));
const Floor_1 = __importDefault(require("../three/element/Floor"));
const Util_1 = __importDefault(require("../Util"));
const Text_1 = __importDefault(require("../three/element/Text"));
class ChapterStairs extends Chapter_1.default {
    constructor(stage, text, key) {
        super();
        this.text = text;
        this.key = key;
        this.stage = stage;
        this.stairs = [];
        this.container = null;
        this.floor = null;
        this.txtKo = null;
    }
    start() {
        this.stage.renderer.setClearColor(0x000000, 1);
        this.stage.scene.fog = new THREE.Fog(0x000000, 2, 21);
        this.stage.camera.position.set(-0.14, 2.17, 8.83);
        this.stage.controls.target.set(0, 0, 0);
        this.stage.controls.update();
        this.stage.grid.setWhite();
        this.stage.fixCameraBasePos();
        this._create();
        this._rise(3).then(() => {
            if (this.floor)
                this.floor.visible = false;
            if (this.container)
                this.container.visible = true;
            this.done(0);
        });
        this.dispatchTextWhite();
    }
    update() {
        var _a;
        this.stairs.forEach((plane) => plane.update());
        (_a = this.floor) === null || _a === void 0 ? void 0 : _a.update();
    }
    stop(cb) {
        this._check(1)
            .then(() => this._flap())
            .then(() => {
            this.container && this.stage.remove(this.container);
            this.floor && this.stage.remove(this.floor);
            this.txtKo && this.stage.remove(this.txtKo);
            this.container = null;
            this.stairs = [];
            this.floor = null;
            this.txtKo = null;
            cb();
        });
    }
    _create() {
        this.floor = new Floor_1.default(20, 20);
        this.floor.position.set(0, -15, 0);
        this.floor.rotation.y = Math.PI / 4;
        this.stage.add(this.floor);
        this.container = new THREE.Object3D();
        this.container.rotation.y = Math.PI / 4;
        this.container.visible = false;
        this.stage.add(this.container);
        const length = 20;
        for (let i = 0; i < length; i++) {
            for (let j = 0; j < length; j++) {
                const plane = new SplashCircle_1.default(1, 1);
                plane.rotation.y = (i * Math.PI) / 2;
                plane.position.set(-length / 2 + 0.5 + j, 0, length / 2 - 0.5 - i);
                plane.setFog(this.stage.scene.fog);
                this.stairs.push(plane);
                this.container.add(plane);
            }
        }
        this.txtKo = new Text_1.default(2.8, 0.7, this.stage.cache.get('textStairs'));
        this.txtKo.position.set(0, 1.6, -0.1);
        this.stage.add(this.txtKo);
    }
    _rise(duration) {
        var _a;
        gsap_1.gsap.delayedCall(1.2, () => {
            var _a;
            (_a = this.txtKo) === null || _a === void 0 ? void 0 : _a.fadeIn(3);
            this.showText(0, 'black');
        });
        (_a = this.floor) === null || _a === void 0 ? void 0 : _a.rise(duration);
        return new Promise(resolve => gsap_1.gsap.delayedCall(duration + 0.1, () => resolve()));
    }
    _check(duration) {
        this.stairs.forEach((plane, i) => {
            gsap_1.gsap.delayedCall(Util_1.default.random(0, duration), () => plane.drawStep());
        });
        return new Promise(resolve => gsap_1.gsap.delayedCall(duration, () => resolve()));
    }
    _flap() {
        gsap_1.gsap.delayedCall(1, () => { var _a; return (_a = this.txtKo) === null || _a === void 0 ? void 0 : _a.fadeOut(0.5); });
        this.stairs.forEach((plane, i) => {
            gsap_1.gsap.to(plane.position, {
                duration: Util_1.default.random(2, 4),
                x: plane.position.x * 2,
                y: Util_1.default.random(10, 13),
                ease: `back.inOut(${Util_1.default.random(1.2, 2)})`,
            });
            gsap_1.gsap.to(plane.rotation, {
                duration: Util_1.default.random(2, 4),
                x: Util_1.default.random(-0.1, 1),
                ease: 'power3.inOut',
            });
            plane.drawFlap();
        });
        return new Promise(resolve => gsap_1.gsap.delayedCall(4, () => resolve()));
    }
}
exports.default = ChapterStairs;
